import api from "@/services/api"

type SendBusinessFundingCommsRequest = {
  email: string
}

export const sendBusinessFundingComms = async (
  request: SendBusinessFundingCommsRequest
) => {
  await api.post(`/send-business-funding-comms/`, {
    body: request,
  })
}
